import { Component, Input, OnInit } from '@angular/core';
import { PaymentInterface } from '../../../payments/models/payment.interface';
import { select, Store } from '@ngrx/store';
import { ConstsHelper } from '../../../../helpers/consts.helper';
import { LineInterfaceState } from '../../../lines/store/state/line.state';
import { LandLineListInterface } from '../../../landlines/models/land-line-list.interface';
import { SelectedLandLineInterfaceState } from '../../../landlines/store/state/selected-land-line.state';

@Component({
    selector: 'app-dot',
    templateUrl: './dot.component.html',
    styleUrls: ['./dot.component.css'],
    standalone: false
})

export class DotComponent implements OnInit  {
    @Input()
    dynamicClass?: string;

    @Input()
    dynamicStatus?: string;

    @Input()
    payment?: PaymentInterface;

    @Input()
    landLine: LandLineListInterface;

    class: string;

    constructor(private store: Store<any>) {}

    ngOnInit() {
        this.store.pipe(select(ConstsHelper.REDUCER_LINE)).subscribe((response: LineInterfaceState) => {
            if (response.line !== null) {
                this.setClass(response.line.status);
            }
        });

        this.store.pipe(select(ConstsHelper.REDUCER_LAND_LINE)).subscribe((response: SelectedLandLineInterfaceState) => {
            if (response.line !== null) {
                this.setClass(response.line.status);
            }
        });
        this.setNonLineClass();
    }

    private setClass(status?: string) {
        switch (status) {
            case 'Active':
                this.class = 'green';
                break;
            case 'Résiliée':
                this.class = 'red';
                break;
            case 'Suspendue':
                this.class = 'orange';
                break;
            case 'Rétractée':
                this.class = 'red';
                break;
            case 'En attente d\'activation':
                this.class = 'blue';
                break;
        }
    }

    private setNonLineClass() {
        if (this.payment) {
            this.class = this.payment.amount > 0 ? 'green' : 'red';
        }
        if (this.dynamicClass) {
            this.class = this.dynamicClass;
        }
        if (this.dynamicStatus) {
            this.setClass(this.dynamicStatus);
        }
        if (this.landLine && !this.dynamicStatus && !this.dynamicClass) {
            this.setClass(this.landLine.status.charAt(0).toUpperCase() + this.landLine.status.substr(1, this.landLine.status.length));
        }
    }
}
